export default "__VITE_ASSET__BeJC_orF__"